/*!
 * devextreme-angular
 * Version: 22.1.11
 * Build date: Mon Aug 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-indent',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoIndentComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get left(): number | undefined {
        return this._getOption('left');
    }
    set left(value: number | undefined) {
        this._setOption('left', value);
    }

    @Input()
    get right(): number | undefined {
        return this._getOption('right');
    }
    set right(value: number | undefined) {
        this._setOption('right', value);
    }


    protected get _optionPath() {
        return 'indent';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoIndentComponent
  ],
  exports: [
    DxoIndentComponent
  ],
})
export class DxoIndentModule { }
